module.exports = __webpack_public_path__ + "img/10.9bf50978.jpg";